<template>
  <n-modal class="page-record-create" :loading="$var('load')" @close="$emit('close')">
    <div class="line">
      <n-card class="info" :loading="$var('load')">
        <template #header>
          <h3>Информация</h3>
        </template>
        <n-items>
          <n-input title="Проект" :value="project.title" text />
          <n-input title="Дата заполнения" v-bind="$form.input('publishedAt')" />
        </n-items>
      </n-card>
    </div>
    
    <n-card :loading="$var('load')">
      <template #header>
        <h3>{{ journal.title }}</h3>
      </template>
      <n-items>
        <n-input title="№ п/п" v-bind="$form.input('number')" />
        <n-input title="Номер сварного соединения по чертежам (исполнительные чертежи)" v-bind="$form.input('numberWelding')" />
        <n-input title="Труба Д * S, мм" v-bind="$form.input('pipe')" />
        <n-input title="Марка стали" v-bind="$form.input('steelMark')" />
        <n-input title="Тип электродов, марка сварной проволоки" v-bind="$form.input('electrodType')" />
        <n-datepicker title="Дата сварки " v-bind="$form.input('weldingDate')" inline />
        <n-datepicker inline title="Дата сварки термической обработки" v-bind="$form.input('termingDate')"  />
        <n-input title="Вид термической обработки" v-bind="$form.input('termingType')" />
        <n-input title="Способ нагрева" v-bind="$form.input('heatingWay')" />
        <n-input title="Метод контроля температуры" v-bind="$form.input('tempControlMethod')" />
        <n-input title="Номер диаграмм или время замера температуры" v-bind="$form.input('diagramNum')" />
        <n-input title="Термическая обработка: Температура нагрева, С" v-bind="$form.input('heatingTemp')" />
        <n-input title="Термическая обработка: Скорость нагрева, С/ч" v-bind="$form.input('heatingSpeed')" />
        <n-input title="Термическая обработка: Время выдержки, ч" v-bind="$form.input('heatingTime')" />
        <n-input title="Термическая обработка: Характер охлаждения" v-bind="$form.input('coolingChar')" />
        <n-input title="Номер протокола замеровтвердости, дата" v-bind="$form.input('protocolNum')" />
        <n-input title="Оценка годности сварного соединения после термообработки" v-bind="$form.input('weldingGrade')" />
      </n-items>
    </n-card>
    
    <n-card>
      <n-divide>
        <div></div>
        <n-button color="success" @click="save">Сохранить</n-button>
      </n-divide>
    </n-card>
  </n-modal>
</template>

<script>
export default {
  name: 'PageRecordCreate',
  props: [ 'project', 'journal', ],
  data() {
    return {
      figures: [],
    }
  },
  created() {
    this.$form.init({
      publishedAt: $app.date.format($app.date.now()),
    })
  },
  methods: {
    save() {
      this.$var('load', true)
      const data = {
        record: this.$form.get(),
      }
      $api.journals.records.create(this.project.id, this.journal.name, data).then((response) => {
        this.$emit('reload')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .page-record-create {
    
    .line {
      display: flex;
      align-items: flex-start;
      
      & > * {
        white-space: normal;
        display: inline-block;
        margin-bottom: 0;
        flex-grow: .4;
        flex-basis: 1px;
      }
      .items {
        margin-left: 0;
        flex-grow: .6;
      }
    }
    
    
    .weather {
      .unit {
        margin: 0 20px 0 5px;
      }
      .temperature {
        margin-left: 20px;
      }
      .temperature, .wind {
        width: 100px;
      }
    }
    
    .add {
      margin-top: 5px;
      font-size: .8em;
      opacity: .7;
      cursor: pointer;
    }
  }
</style>
